import * as React from 'react';
import Avatar from '@mui/material/Avatar';

function stringToColor(string) {
  let hash = 0;
  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    color += ('00' + value.toString(12)).substr(-2);
  }
  return color;
}

function stringAvatar(name) {
  if (!name) {
    return null;
  }

  const nameParts = name.split(' ');
  return {
    sx: {
      bgcolor: stringToColor(name),
      textTransform: 'uppercase',
    },
    children: `${nameParts[0][0]}${nameParts[1][0]}`,
  };
}

export default function ProfileAvatar({ name }) {
  return <Avatar {...stringAvatar(name)} />;
}
